import type { ReactNode } from 'react'
import { Button } from '../primitives/Button'
import s from './ErrorNote.module.css'

/**
 * When data didn't load, or a screen broke. Keep the message plain, and end with what to do.
 * `title` defaults to "This didn't load"; `actions` adds buttons after Try again; `detail` shows preformatted text
 * (the error and component stack, in development only); `children` go under the message.
 */
export function ErrorNote(props: {
  message: string
  onRetry?: () => void
  title?: string
  actions?: ReactNode
  detail?: string
  children?: ReactNode
}) {
  return (
    <div className={s.note} role="alert">
      <h3 className={s.title}>{props.title ?? "This didn't load"}</h3>
      <p className={s.message}>{props.message}</p>
      {props.children && <div className={s.message}>{props.children}</div>}
      {props.detail && <pre className={s.detail}>{props.detail}</pre>}
      {(props.onRetry || props.actions) && (
        <div className={s.actions}>
          {props.onRetry && <Button onClick={props.onRetry}>Try again</Button>}
          {props.actions}
        </div>
      )}
    </div>
  )
}
